var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSlideshow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.0622 32C28.0622 31.2754 28.6503 30.6874 29.3761 30.6874C30.102 30.6874 30.6874 31.2754 30.6874 32C30.6874 32.7246 30.102 33.3126 29.3761 33.3126C28.6503 33.3126 28.0622 32.7246 28.0622 32ZM36.2004 32L33.9689 35.4128L32.2625 33.3126L28.0622 38.563H41.1883L36.2004 32ZM43.8135 22.8118V20.1866H16.2488V39.8756H18.874V22.8118H43.8135ZM47.7513 25.437V43.8134H21.4992V25.437H47.7513ZM45.1261 28.0622H24.1244V41.1882H45.1261V28.0622Z",
    fill: "currentcolor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlideshow);
export default __webpack_public_path__ + "static/media/slideshow.044be214.svg";
export { ForwardRef as ReactComponent };